import { ProductGroupMetrics,WarehouseMetrics,ProductInfo } from '../../models/NV02Lava';
import * as actionTypesNV02 from '../actions/actionTypesNV02';
import * as fromApp from "../rootReducer";

export interface NV02 {
  ProductGroupMetrics: ProductGroupMetrics[];
  WarehouseMetrics: WarehouseMetrics[];
  ProductInfo: ProductInfo[];
  LagerKode: any;
  error: any;
  isFetching: boolean;
  isFetchingGroup: boolean;
  isFetchingProductInfo: boolean;
  isFetchingLagerKode: boolean;
}
const initialState: NV02 = {
  ProductGroupMetrics: [],
  WarehouseMetrics: [],
  ProductInfo: [],
  LagerKode: null,
  error: undefined,
  isFetching: false,
  isFetchingGroup: false,
  isFetchingProductInfo: false,
  isFetchingLagerKode: false,
};

const NV02Reducer = (state = initialState, action: any) => {
  switch (action.type) {
    case actionTypesNV02.WAREHOUSE_METRICS_GET:
    return {
        ...state,
        isFetching: true,
        error: undefined,
      };
    case actionTypesNV02.WAREHOUSE_METRICS_GET_SUCCESS:
      return {
        ...state,
        WarehouseMetrics: action.payload,
        isFetching: false,
        error: undefined,
      };
    case actionTypesNV02.WAREHOUSE_METRICS_GET_FAILURE:
      return {
        ...state,
        isFetching: false,
        error: action.payload,
      };
      case actionTypesNV02.WAREHOUSE_METRICS_RESET:
      
        return{
          ...initialState
        };  
        case actionTypesNV02.PRODUCT_METRICS_GET:
          return {
            ...state,
            isFetchingGroup: true,
            error: undefined,
          };
    
        case actionTypesNV02.PRODUCT_METRICS_GET_SUCCESS:
          return {
            ...state,
            ProductGroupMetrics: action.payload,
            isFetchingGroup: false,
            error: undefined,
          };
    
        case actionTypesNV02.PRODUCT_METRICS_GET_FAILURE:
          return {
            ...state,
            isFetchingGroup: false,
            error: action.payload,
          };
    
        case actionTypesNV02.PRODUCT_METRICS_RESET:
          return {
            ...initialState,
          }; 
    case actionTypesNV02.PRODUCT_BY_GROUP_GET:
      return {
        ...state,
        isFetchingProductInfo: true,
        error: undefined,
      };
    case actionTypesNV02.PRODUCT_BY_GROUP_GET_SUCCESS:
      return {
        ...state,
        ProductInfo: action.payload,
        isFetchingProductInfo: false,
        error: undefined,
      };
    case actionTypesNV02.PRODUCT_BY_GROUP_GET_FAILURE:
      return {
        ...state,
        isFetchingProductInfo: false,
        error: action.payload,
      };
    case actionTypesNV02.PRODUCT_BY_GROUP_RESET:
      return {
        ...state,
        ProductInfo: [],
        isFetchingProductInfo: false,
        error: undefined,
      };

    case actionTypesNV02.LAGERKODE_GET:
      return {
        ...state,
        isFetchingLagerKode: true,
        error: undefined,
      };

    case actionTypesNV02.LAGERKODE_GET_SUCCESS:
      return {
        ...state,
        LagerKode: action.payload,
        isFetchingLagerKode: false,
        error: undefined,
      };

    case actionTypesNV02.LAGERKODE_GET_FAILURE:
      return {
        ...state,
        isFetchingLagerKode: false,
        error: action.payload,
      };

    case actionTypesNV02.LAGERKODE_RESET:
      return {
        ...state,
        LagerKode: null,
        isFetchingLagerKode: false,
        error: undefined,
      };
          
      
    default:
      return state;
  }
};

export default NV02Reducer;